module.exports = __webpack_public_path__ + "static/img/11areaA_02.5763310.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/11areaA_02.png
// module id = 958
// module chunks = 1